export default __webpack_public_path__ + "static/media/login-background.01d3dc2e.png";